<template>
    <div class="flex flex-col gap-3 justify-center text-[var(--color-text-body)]">
        <h1 class="text-3xl text-center md:text-5xl text-[var(--color-text-heading-from)] font-bold">Bienvenido a
            SkyRoutes</h1>

        <section class=" mx-10 flex flex-col gap-2 items-center">

            <p class="container">
                Tu plataforma líder para la creación y planificación de planes de vuelo con la potencia de
                OpenStreetMap.
            </p>
            <p class="container">
                Nuestra misión es ofrecerte una experiencia única y emocionante al planificar tus vuelos. Ya seas un
                entusiasta de la aviación, un piloto profesional o simplemente alguien que ama viajar por los cielos.

            </p>


            <p class="container mt-3 font-semibold text-[var(--color-text-heading-from)]">
                ¿Qué nos hace diferentes?
            </p>
            <p class="container">
                En SkyRoutes, entendemos que la planificación de vuelos puede ser una tarea complicada y requerir mucho
                tiempo. Por eso hemos creado una plataforma intuitiva y fácil de usar que te permite crear, visualizar y
                ajustar tus planes de vuelo con una interfaz sencilla y amigable.
            </p>


            <p class="container">
                Ya sea que estés planeando un emocionante viaje de placer, una misión de vuelo profesional o simplemente
                explorando nuevos horizontes, SkyRoutes te ofrece las herramientas y recursos para que tus sueños
                despeguen con confianza y precisión.
            </p>
            <p class="container mt-3">
                Únete a nuestra comunidad de apasionados de la aviación y comienza a crear planes de vuelo memorables
                hoy mismo.
            </p>

            <article class="flex flex-wrap gap-2 justify-around mt-4">
                <img class="rounded border border-[var(--color-border-subtle)] w-32 h-auto flex justify-center items-center transform transition-transform duration-500 hover:scale-150 hover:z-10 bg-white/5"
                    src="/imgs/Ai1.jpg" alt="aircraft">
                <img class="rounded border border-[var(--color-border-subtle)] w-32 h-auto flex justify-center items-center transform transition-transform duration-500 hover:scale-150 hover:z-10 bg-white/5"
                    src="/imgs/fp3.png" alt="aircraft">
                <img class="rounded border border-[var(--color-border-subtle)] w-32 h-auto flex justify-center items-center transform transition-transform duration-500 hover:scale-150 hover:z-10 bg-white/5"
                    src="/imgs/FP.jpg" alt="aircraft">
                <img class="rounded border border-[var(--color-border-subtle)] w-32 h-auto flex justify-center items-center transform transition-transform duration-500 hover:scale-150 hover:z-10 bg-white/5"
                    src="/imgs/route.jpg" alt="aircraft">
                <img class="rounded border border-[var(--color-border-subtle)] w-32 h-auto flex justify-center items-center transform transition-transform duration-500 hover:scale-150 hover:z-10 bg-white/5"
                    src="/imgs/EN-Spain.png" alt="aircraft">
                <img class="rounded border border-[var(--color-border-subtle)] w-32 h-34 flex justify-center items-center transform transition-transform duration-500 hover:scale-150 hover:z-10 bg-white/5"
                    src="/imgs/fmc.png" alt="aircraft">
            </article>

            <strong
                class="container flex flex-col justify-center items-center m-4 text-3xl text-[var(--color-text-heading-from)] text-center">
                ¡Despliega tus alas y alcanza nuevos horizontes con SkyRoutes!
            </strong>
        </section>
    </div>
</template>
